/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

// DEPENDENCIES
import React from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
// CUSTOM COMPONENTS
import Layout from "../_metronic/layout/components/Layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import ClientProposalApprovalPage from './pages/clients/ClientProposalApprovalPage';
import AlertSnackBar from "./components/AlertSnackBar";
import ConfirmModal from "./components/ConfirmModal";
import GeoLocationErrorPage from "./pages/errors/GeoLocationErrorPage";
import {ProposalApproveSuccessPage} from './modules/SuccessMessagePage/ProposalApproveSuccessPage';

export function Routes() {
    const { isAuthorized } = useSelector(
        ({ auth }) => ({
            isAuthorized: auth.user != null,
        }),
        shallowEqual

    );
    return (
        <>
            <Switch>
                <Route path="/approve-proposal" component={ClientProposalApprovalPage} />
                <Route path="/approval-success" component={ProposalApproveSuccessPage} />
                <Route path="/error" component={ErrorsPage} />
                {!isAuthorized ? (
                    /*Render auth page when user at `/auth` and not authorized.*/
                    <Route>
                        <AuthPage />
                    </Route>
                ) : (
                    /*Otherwise redirect to root page (`/`)*/
                    <Redirect from="/auth" to="/" />
                )}

                <Route path="/error" component={ErrorsPage} />
                <Route path="/logout" component={Logout} />
                <Route path="/geo-location-error" component={GeoLocationErrorPage} />


                {!isAuthorized ? (
                    /*Redirect to `/auth` when user is not authorized*/
                    <Redirect to="/auth/login" />
                ) : (
                    <Layout>
                        <BasePage />
                    </Layout>
                )}
            </Switch>
            <AlertSnackBar />
            <ConfirmModal />
        </>
    );
}
